export default function JoinLeagueModal() {
    const formWrapper = document.querySelector('.join-league-form-wrapper');
    if (!formWrapper) return;

    const submitBtn = formWrapper.querySelector('#submitLeaguePassword');
    const passwordInput = formWrapper.querySelector('#modalLeaguePassword');
    const errorEl = formWrapper.querySelector('#modalPasswordError');
    const formEl = formWrapper.querySelector('form');
    const modalEl = formWrapper.querySelector('#privateLeagueModal');

    if (!submitBtn || !passwordInput || !formEl || !modalEl) return;

    // Grab the hidden "password" from data-theme-id
    const leaguePasswordHidden = formWrapper.dataset.themeId;

    submitBtn.addEventListener('click', () => {
        errorEl.style.display = 'none';
        const enteredPassword = passwordInput.value.trim();

        if (!enteredPassword) {
            errorEl.textContent = 'Please enter the league password.';
            errorEl.style.display = 'block';
            return;
        }

        // Compare against the hidden "password"
        if (enteredPassword === leaguePasswordHidden) {
            const modalInstance = bootstrap.Modal.getInstance(modalEl);
            if (modalInstance) modalInstance.hide();
            formEl.submit();
        } else {
            errorEl.textContent = 'Incorrect password. Please try again.';
            errorEl.style.display = 'block';
        }
    });
}